(function () {
  'use strict';

  angular.module('ringbaPortal').component('callPlanForm', {
    bindings: {
      currentCallPlan: '<', //used in edit mode
      onDismiss: '&',
      onSave: '&'
    },
    controller: CallPlanFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/call-plans/call-plan-form.view.html'
  });

  function CallPlanFormController(
    $filter,
    accountsService,
    callPlanService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.routingOptions = [
      { name: $filter('translate')('ROUTING_TYPE_PRIORITY'), value: 'PRIORITY' },
      { name: $filter('translate')('ROUTING_TYPE_RPC'), value: 'RPC' },
    ];

    vm.defaultCallPlan = {
      name: '',
      routingType: 'PRIORITY',
    };

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onSubmit = onSubmit;
    vm.cancel = cancel;
    vm.onRPCChange = onRPCChange;
    vm.onRoutingTypeToggled = onRoutingTypeToggled;

    function onInit() {
      if (vm.currentCallPlan) {
        vm.currentCallPlan = angular.copy(vm.currentCallPlan);
      } else {
        _initNewCallPlan();
      }
      _initRpcSettingItem();
    }

    function onChanges() {
      if (!vm.currentCallPlan) {
        _initNewCallPlan();
      }
      _initRpcSettingItem();
    }

    function onSubmit() {
      if (!vm.currentCallPlan.id) {
        return _createCallPlan();
      } else {
        return _updateCallPlan();
      }
    }

    function cancel() {
      const eventObj = vm.currentCallPlan ? {
        callPlan: vm.currentCallPlan
      } : {};
      vm.onDismiss({
        $event: eventObj
      });
    }

    function onRoutingTypeToggled(option) {
      vm.currentCallPlan.routingType = option.value;
      vm.rpcItem = {
        enabled: option.value === 'RPC' ? true : false,
        id: ''
      };

    }

    function onRPCChange(value) {
      vm.rpcItem.id = value;
    }

    function _handleLinkRpc(callPlan) {
      const callPlanId = callPlan && callPlan.id;
      if (callPlanId) {
        if (vm.rpcItem && vm.rpcItem.id) {
          if (!callPlan.rpc || vm.rpcItem.id !== callPlan.rpc.id) {
            return callPlanService.linkToItem(accountsService.currentAccountId, callPlanId, {
              memberName: 'RPC',
              memberId: vm.rpcItem.id
            });
          }
        } else {
          if (callPlan.rpc && callPlan.rpc.id) {
            return callPlanService.unlinkItem(accountsService.currentAccountId, callPlanId, {
              memberName: 'RPC',
              memberId: callPlan.rpc.id
            });
          }
        }
      }
    }

    function _initNewCallPlan() {
      vm.currentCallPlan = angular.copy(vm.defaultCallPlan);
    }

    function _initRpcSettingItem() {
      if (vm.currentCallPlan?.rpc && vm.currentCallPlan?.rpc?.id) {
        vm.rpcItem = angular.copy(vm.currentCallPlan.rpc);
        return;
      }
      vm.rpcItem = {
        enabled: vm.currentCallPlan.routingType === 'RPC' ? true : false,
        id: ''
      };
    }

    async function _createCallPlan() {
      try {
        const response = await callPlanService.createCallPlan(accountsService.currentAccountId, vm.currentCallPlan.name, vm.currentCallPlan.routingType);
        await _handleLinkRpc(response.callPlan);
        toaster.pop('success', $filter('translate')('CALL_PLANS_SUCCESSFULLY_CREATED'));
        vm.onSave({
          callPlan: response.callPlan
        });
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    async function _updateCallPlan() {
      delete vm.currentCallPlan.showEditForm;
      const currentCallPlan = angular.copy(vm.currentCallPlan);
      if (vm.currentCallPlan.rpc)
        delete vm.currentCallPlan.rpc;

      try {
        await callPlanService.updateCallPlan(accountsService.currentAccountId, vm.currentCallPlan);
        await _handleLinkRpc(currentCallPlan);
        toaster.pop('success', $filter('translate')('CALL_PLANS_SUCCESSFULLY_UPDATED'));
        vm.onSave();
        cancel();
      } catch (e) {
        utils.errorHandler(e);
      }
    }

  }
})();
